import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';
import ButtonTwo from '../Button/ButtonTwo';

import Image from '../../assets/img/blog/blog-3-1.jpg';

const SingleBlogTwo = (props) => {
  const {
    itemClass,
    blogImage,
    publishedDate,
    titleClass,
    title,
    description,
    hasArrow,
    btnClass,
    btnText,
  } = props;

  return (
    <div className={itemClass ? itemClass : 'it-blog-2-item'}>
      <div className="it-blog-2-thumb mb-40 fix">
        <Link to="/blog-details">
          <img src={blogImage ? blogImage : Image} alt="" />
        </Link>
      </div>
      <div className="it-blog-2-content">
        <div className="it-blog-2-meta pb-10">
          <span>{publishedDate ? publishedDate : '15 JUNE, 24'}</span>
        </div>
        <h4 className="it-blog-title mb-0 pb-15">
          <Link
            className={titleClass ? titleClass : 'hover-anim tertiary'}
            to="/blog-details"
          >
            {title ? title : 'Healthcare Tips Navigating Business Patient Care'}
          </Link>
        </h4>
        <p className="mb-25">
          {description
            ? description
            : 'Lorem ipsum dolor sit a met, consectetur adipiscing elit, sed eiusmod tempor incididunt ut labore et dolore magna aliqua.'}
        </p>
        {hasArrow ? (
          <ButtonTwo
            btnURL="/blog-details"
            btnClass="it-btn-theme blog-btn red-bg mr-35"
            btnText={btnText ? btnText : 'Read More'}
          />
        ) : (
          <Link
            to="/blog-details"
            className={
              btnClass ? btnClass : 'it-btn-theme blog-btn tertiary-bg'
            }
          >
            <Button btnText={btnText ? btnText : 'Read More'} />
          </Link>
        )}
      </div>
    </div>
  );
};

export default SingleBlogTwo;
